import {createContext} from 'react';

export const NavigationContext = createContext<{
  showChatbot: boolean;
  setShowChatbot: (isOpen: boolean) => void;
  hideIcon: boolean;
  setHideIcon: (hide: boolean) => void;
}>({
  showChatbot: false,
  setShowChatbot: () => {},
  hideIcon: false,
  setHideIcon: () => {}
});
